import { Project, Lot, JobType } from '@zayan-erp/home-building';

export interface SchedulerUserRole {
  roleId: string;
  name: string;
}
export interface SchedulerUser {
  id: string;
  firstName: string;
  lastname: string;
  userRoles: Omit<SchedulerUserRole, 'id'> &
    {
      roleId: string;
    }[];
  userProjects: Omit<Project, 'id'> &
    {
      projectId: string;
    }[];
}

export interface Stage {
  id: string;
  stageCode: string;
  stageName: string;
}

export interface Task {
  id: string;
  taskCode: string;
  taskName: string;
  stage: Stage;
  jobType?: JobType;
  majorCode?: string;
  minorCode?: string;
  craft?: Craft;
  inActive: boolean;
}
export type TaskFormItem = Omit<Task, 'id' | 'stage' | 'inActive' | 'craft' | 'jobType'> & {
  stageId: string;
  craftId?: string | null;
  jobTypeId?: string | null;
};

export interface TaskImportTableItemMetadata {
  value: string | number | null;
  isValid: boolean;
  message: string | null;
  isDuplicate: boolean;
}

export interface TaskTableItem {
  taskCode: string;
  taskName: string;
  stageCode: string;
  jobTypeId?: string | null;
  majorCode?: string | null;
  minorCode?: string | null;
  craftCode?: string | null;
}

export interface TaskImportTableItem {
  taskCode: TaskImportTableItemMetadata;
  taskName: TaskImportTableItemMetadata;
  stageCode: TaskImportTableItemMetadata;
  jobTypeId: TaskImportTableItemMetadata;
  majorCode: TaskImportTableItemMetadata;
  minorCode: TaskImportTableItemMetadata;
  craftCode: TaskImportTableItemMetadata;
  inEditMode: boolean;
}

export interface Stage {
  id: string;
  code: string;
  name: string;
}
export interface Craft {
  id: string;
  code: string;
  description: string;
}

export interface Schedule {
  id: string;
  code: string;
  name: string;
}

export interface ScheduleTask {
  id: string;
  taskId: string;
  duration: number;
  predecessorTaskId?: string;
  predecessorId?: string;
  milestone: boolean;
  floatDay?: number;
  sequence: number;
}

export interface ScheduleWithTasks extends Schedule {
  scheduleTasks: ScheduleTask[];
}

// Add new interfaces
export interface ScheduleTaskImportTableItem {
  taskCode: ScheduleTaskImportTableItemMetadata;
  duration: ScheduleTaskImportTableItemMetadata;
  predecessorTask: ScheduleTaskImportTableItemMetadata;
  milestone: ScheduleTaskImportTableItemMetadata;
  floatDay: ScheduleTaskImportTableItemMetadata;
  inEditMode: boolean;
}

export interface ScheduleTaskImportTableItemMetadata {
  isValid: boolean;
  message: string | null;
  value: any;
  isDuplicate: boolean;
}
export const TaskStatus = [
  { id: '0', name: 'All' },
  { id: '1', name: 'Active' },
  { id: '2', name: 'Not Started' },
  { id: '3', name: 'Started' },
  { id: '4', name: 'Completed' },
  { id: '5', name: 'Completed with Exception' },
  { id: '6', name: 'Skip' }
];
export const SortByEntities = [
  { id: '8', name: 'Task Sequence' },
  { id: '9', name: 'Actual Start Date' },
  { id: '10', name: 'Actual End Date' },
  { id: '11', name: 'Revised Start Date' },
  { id: '12', name: 'Revised End Date' },
  { id: '13', name: 'Planned Start Date' },
  { id: '14', name: 'Planned End Date' }
];
export const OrderEntities = [
  { id: '0', name: 'Ascending' },
  { id: '1', name: 'Descending' }
];
export interface ScheduleLotFilters {
  searchTerm?: string;
  OUnitCodeId?: string | null;
  ProjectId?: string | null;
  LotId?: string | null;
  ScheduleId?: string | null;
  TaskId?: string | null;
  StageId?: string | null;
  StatusBy?: string | null;
  SortBy?: string | null;
  SortOrder: string | number;
  PageNumber?: number;
  PageSize: number;
}
export type ScheduleLotFiltersCollapsable = Required<
  Omit<ScheduleLotFilters, 'searchTerm' | 'PageSize' | 'PageNumber'>
>;

export interface LotScheduleTaskItem {
  id: string;
  inActive: boolean;
  lot: Pick<Lot, 'id' | 'lotNo' | 'buyerName'>;
  lotId: string;
  schedule: Pick<Schedule, 'id' | 'code' | 'name'>;
  scheduleId: string;
  scheduleLotTasks: ScheduleTask[];
  startDate: string;
}

export type LotScheduleTaskLookupItem = {
  id: string;
  oUnitCode: string;
  projectId: string;
  projectName: string;
  lotId: string;
  lotNo: string;
  taskName: string;
  taskId: string;
  stageId: string;
  stageName: string;
  sequence: number;
  duration: number;
  predecessorId: string;
  predecessorName: string | null;
  milestone: boolean;
  floatDay: number;
  status: TaskStatusEnum | null;
  actualStartDate: string | null;
  actualEndDate: string | null;
  revisedStartDate: string;
  revisedEndDate: string;
  plannedStartDate: string;
  plannedEndDate: string;
  completedDate: string | null;
  exceptionReason: string | null;
  isOnHold: boolean | null;
  isLotOnHold: boolean;
  okToPay: boolean | null;
};
export enum TaskStatusEnum {
  NOT_STARTED = 'Not Started',
  STARTED = 'Started',
  ACTIVE = 'Active',
  COMPLETED = 'Completed',
  COMPLETED_WITH_EXCEPTION = 'Exception',
  SKIP = 'Skip',
  IS_ON_HOLD = 'On Hold'
}
